
    export default 
    {
    "new_feature": {
        "csv_bulk_order": "Pedido masivo en CSV",
        "describe": "Para usuarios que no utilizan el servicio de Shopify"
    }
}